/**
 * Full Tour — Dark Theme styles for react-select
 * Paleta: fundo #1e3a5a · borda #2a4f72 · texto #e8f0fb · acento #62DEC2
 */

export const darkSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#1e3a5a',
    borderColor: state.isFocused ? '#62DEC2' : '#2a4f72',
    borderRadius: '10px',
    boxShadow: state.isFocused ? '0 0 0 1px #62DEC2' : 'none',
    color: '#e8f0fb',
    '&:hover': {
      borderColor: '#62DEC2',
    },
  }),

  menu: (provided) => ({
    ...provided,
    backgroundColor: '#172B4D',
    border: '1px solid #2a4f72',
    borderRadius: '10px',
    boxShadow: '0 4px 18px rgba(0,0,0,0.4)',
    zIndex: 9999,
  }),

  menuList: (provided) => ({
    ...provided,
    backgroundColor: '#172B4D',
    borderRadius: '10px',
    padding: '4px',
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#1e3a5a'
      : state.isFocused
      ? '#1e3a5a'
      : 'transparent',
    color: state.isSelected ? '#62DEC2' : '#e8f0fb',
    cursor: 'pointer',
    borderRadius: '6px',
    textTransform: 'capitalize',
    '&:active': {
      backgroundColor: '#2a4f72',
    },
  }),

  singleValue: (provided) => ({
    ...provided,
    color: '#e8f0fb',
  }),

  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#2a4f72',
  }),

  multiValueLabel: (provided) => ({
    ...provided,
    color: '#e8f0fb',
  }),

  multiValueRemove: (provided) => ({
    ...provided,
    color: '#8ba5c4',
    '&:hover': {
      backgroundColor: '#1e3a5a',
      color: '#62DEC2',
    },
  }),

  placeholder: (provided) => ({
    ...provided,
    color: '#8ba5c4',
  }),

  input: (provided) => ({
    ...provided,
    color: '#e8f0fb',
    marginLeft: '0px',
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
  }),

  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: '#2a4f72',
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#8ba5c4',
    '&:hover': {
      color: '#62DEC2',
    },
  }),

  clearIndicator: (provided) => ({
    ...provided,
    color: '#8ba5c4',
    '&:hover': {
      color: '#62DEC2',
    },
  }),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#8ba5c4',
  }),

  loadingMessage: (provided) => ({
    ...provided,
    color: '#8ba5c4',
  }),
};

/**
 * Variante com menu largo — usada nos filtros do cupos/calendar
 * Controle transparente (pill customizado por cima), menu renderizado via portal no body
 */
export const darkSelectStylesWide = {
  ...darkSelectStyles,
  control: (provided, state) => ({
    ...darkSelectStyles.control(provided, state),
    width: '100%',
    minWidth: '180px',
    fontSize: '15px',
    opacity: 0,        // oculto — a pill customizada aparece por cima
    height: '48px',
    minHeight: '48px',
    cursor: 'pointer',
  }),
  menu: (provided) => ({
    ...darkSelectStyles.menu(provided),
    minWidth: '220px',
    width: 'max-content',
    zIndex: 99999,
  }),
  option: (provided, state) => ({
    ...darkSelectStyles.option(provided, state),
    fontSize: '14px',
  }),
  multiValue: () => ({ display: 'none' }),
  multiValueLabel: () => ({ display: 'none' }),
  multiValueRemove: () => ({ display: 'none' }),
};

/**
 * Label style escuro — substitui o LabelStyle inline dos componentes
 */
export const darkLabelStyle = {
  transform: 'translate(6px, -6px) scale(0.75)',
  top: '-22px',
  left: '0',
  position: 'relative',
  transformOrigin: 'top left',
  color: '#e8f0fb',
  padding: '0px 4px',
  fontSize: '1rem',
  fontWeight: '400',
  lineHeight: '1',
  letterSpacing: '0.00938em',
  background: 'transparent',
  zIndex: '10006',
};
